import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import * as Constants from "../Common/usermanagementconst";
import "../common.css";

function MappingDunsModal(props) {
  return (
    <>
      <Modal
        show={props.show}
        onHide={props.handleClose}
        size="lg"
        className={props.cls}
      >
        <Modal.Header closeButton>
          <Modal.Title>{props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {Constants.PARENT_CHILD_CONFIRMATION_MSG}
            <span style={{ margin: "0 5px 0 5px" }}>
              <b>{props?.parentData}</b>
            </span>
            {Constants.PARENT_CHILD_CONFIRMATION_MSG_PARENT}
            <span style={{ margin: "0 5px 0 5px" }}>
              <b>{props?.childData}</b>
            </span>
            {Constants.PARENT_CHILD_CONFIRMATION_MSG_CHILD}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.handleClose}>
            {Constants.NO}
          </Button>
          <Button className="mcy-btn-primary" onClick={props.handleSave}>
            {Constants.YES}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default MappingDunsModal;
